import { IGenericIncludeBuilder } from "./IGenericIncludeBuilder.js";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IIncludeBuilder extends IGenericIncludeBuilder<IIncludeBuilder> {

}
